import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const removePaymentCredentials = paymentCredentialsId =>
  call(websocketFetch, 'remove_payment_credentials', {
    payment_credentials_id: paymentCredentialsId,
  });
